import React from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import ReadOnlyWrapper from '../../authorization/ReadOnlyWrapper';
import dateformat from 'dateformat';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
const log = new Logger('FORMATED_DATE', LOG_LEVELS.ERROR);

export class FormattedDate extends React.Component {
  changeHandler = (event) => {
    let changedValue;
    changedValue = event.target.value
    this.props.editOptions.changeHandler(changedValue);
  }

  render() {
    
    // Cater for basic 10 char date string
    let date = new Date(this.props.value)

    // Prevent ISO dateTime string conversion to localTime
    if ((this.props.value) && (this.props.value.length > 10))
    {
      const parts = this.props.value.split('-');
      const day = parts[2].substring(0, 2);
      date = new Date(parts[0], parts[1] - 1, day);
    }

    const invalidDate = isNaN(date.getTime());
    const specialVRDate = date.getFullYear() === 1899;
    const formattedDate = invalidDate ?
      LANGUAGES_CONTROLLER.format(this.props.languages, 'conversionError_invalidDate') :
      (specialVRDate ? '' : dateformat(date, this.props.format));

    if (specialVRDate === true && this.props.editOptions) {
      return (
        <ReadOnlyWrapper>
          <span data-testid="formatted-date-specialVRDate" className={'formatted-date'}>
            <input
              type='date'
              defaultValue=""
              value=""
              onChange={this.changeHandler}
              disabled={this.props.disabled}
              data-testid="formatted-date-input"
            />
          </span>
        </ReadOnlyWrapper>
      )
    }

    if (this.props.editOptions) {
      return (
        <ReadOnlyWrapper>
          <span data-testid="formatted-date-editable" className={'formatted-date'}>
            <input
              type='date'
              value={this.props.value}
              placeholder={this.props.editOptions.prompt || ''}
              onChange={this.changeHandler}
              disabled={this.props.disabled}
              data-testid="formatted-date-input"
            />
          </span>
        </ReadOnlyWrapper>
      )
    }
    return (
      <span data-testid="formatted-date" className={'formatted-date'}>{formattedDate}</span>
    );

  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


FormattedDate.defaultProps = {
  format: 'yyyy-mm-dd',
  disabled: false
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(FormattedDate);